// extracted by mini-css-extract-plugin
export default {"root":"SystemIcon_root__Cg4Km","adaptive":"SystemIcon_adaptive__c3zFM"};